module.exports = __webpack_public_path__ + "static/img/ent-43.d471a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-43.jpg
// module id = 5eRv
// module chunks = 51